/* global localStorage */

import { CognitoUserPool, CognitoUserSession, CognitoIdToken, CognitoAccessToken,
  CognitoRefreshToken, CognitoUser } from 'amazon-cognito-identity-js';
import userpoolconfig from '@/userpoolconfig'

export const getUserPool = () => {
  const poolData = userpoolconfig.cognito;
  return new CognitoUserPool(poolData);
}

const getSessionData = (pool, user) => {
  const keyPrefix = `CognitoIdentityServiceProvider.${pool.getClientId()}.${user.getUsername()}`;
  const idTokenKey = `${keyPrefix}.idToken`;
  const accessTokenKey = `${keyPrefix}.accessToken`;
  const refreshTokenKey = `${keyPrefix}.refreshToken`;
  const clockDriftKey = `${keyPrefix}.clockDrift`;

  const idToken = new CognitoIdToken({IdToken: localStorage.getItem(idTokenKey)});
  const accessToken = new CognitoAccessToken({AccessToken: localStorage.getItem(accessTokenKey)});
  const refreshToken = new CognitoRefreshToken({RefreshToken: localStorage.getItem(refreshTokenKey)});
  const clockDrift = parseInt(localStorage.getItem(clockDriftKey), 0) || 0;

  return {
    IdToken: idToken,
    AccessToken: accessToken,
    RefreshToken: refreshToken,
    ClockDrift: clockDrift,
  };
}

export const getStoredSession = () => {
  const pool = getUserPool();
  const user = pool.getCurrentUser();
  if (user) {
    const sessionData = getSessionData(pool, user);
    try {
      const session = new CognitoUserSession(sessionData)
      return session;
    } catch (err) {
      return undefined;
    }
  } else {
    return undefined;
  }
}

export const getClaim = (key) => {
  const session = getStoredSession();
  if (!session) {
    throw new Error('No session found')
  }
  if (!session.idToken) {
    throw new Error('No idToken found on session')
  }
  if (!session.idToken.payload) {
    throw new Error('No payload found on idToken')
  }
  if (!session.idToken.payload[key]) {
    throw new Error(`Claim with key ${key} not found in token`);
  }
  return session.idToken.payload[key];
}

export const getUnauthorizedUser = (user) => {
  const userPool = getUserPool();

  const userData = {
    Username: user,
    Pool: userPool
  }

  return new CognitoUser(userData);
}

export const isAdmin = () => {
  try {
    const groups = getClaim('cognito:groups')
    console.log(groups);

    return groups.includes('Admin') || groups.includes('Root');
  } catch (err) {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/utils/cognito.js